import { EditOutlined } from '@ant-design/icons';
import { Button, Space, Spin } from 'antd';

import { formatTrustValue } from '@/utils/trust';

type Props = {
    trust?: string | number | null;
    editable?: boolean;
    loading?: boolean;
    onEdit: () => void;
};

const TrustCell: React.FC<Props> = ({ trust, editable, loading, onEdit }) => (
    <Space size={6}>
        <span>{formatTrustValue(trust)}</span>
        {editable ? (
            loading ? (
                <Spin size="small" />
            ) : (
                <Button
                    type="link"
                    size="small"
                    icon={<EditOutlined />}
                    onClick={onEdit}
                    style={{ padding: 0, height: 'auto' }}
                />
            )
        ) : null}
    </Space>
);

export default TrustCell;
